<div [class]="ClassList ? ClassList : ''" class="advertisement_plan_zones">
    <div class="container">
        <h3 class="text-center font_26 font_700 mb-4">المناطق داخل المخطط</h3>

        <!-- start zones -->
        <div class="d-flex align-items-start flex-wrap gap-3">
            <ng-container *ngFor="let zone of Zones">
                <div class="wrap_zone border_solid border_main_color border_radius_4 overflow-hidden flex-grow-1">
                    <div class="wrap_img w-100 pointer" (click)="GetLandsByZone(zone?.id)">
                        <img class="img-fluid img_obj_cover" [src]="zone.img" alt="zone" appImgUrlCheck />
                    </div>
                    <div class="wrap_details bg_white padding_x_2 padding_y_4 d-flex justify-content-between align-items-center flex-wrap gap-1">
                        <h5 class="color_main_color font_14 font_700 mb-0">{{zone.name}}</h5>
                        <div class="text-center">
                            <h6 class="color_black m-0 font_10 font_500">
                                <app-coins-icon class="margin_end" />
                                متوسط سعر المتر
                            </h6>
                            <span class="font_12 font_700 color_main_color">
                                {{zone.averagePrice | number}} <span class="font_10 font_500">ريال</span>
                            </span>
                        </div>
                        <div class="bg_4th_color color_white padding_x_2 padding_y font_10 font_500 border_radius_4">
                            الوحدات المتاحة {{zone?.availableLandsCount}} من {{zone?.landsCount}}
                        </div>
                    </div>
                </div>
            </ng-container>
        </div>
        <!-- end zones -->
        
        <!-- start zone details -->
        <div id="zoneDetails" class="row my-5 position-relative">
            
            <ng-container *ngIf="ActiveZone != null">
                <h3 class="text-center font_26 font_700 mb-4 d-flex justify-content-center align-items-end gap-1">
                    ( {{ActiveZone.name}} )
                    <i class="fa-solid fa-circle-arrow-down fa-gl main_color_4th"></i>
                </h3>
            </ng-container>
            
            <ng-container *ngIf="IsLoading | async">
                <app-loader [preventScroll]="true" [sm]="true" size="fa-8x" />
            </ng-container>

            <!-- start lands -->
            <ng-container *ngIf="Lands.length > 0; else emptyLands">
                <ng-container *ngFor="let land of Lands | paginate: { 
                    itemsPerPage: Limit,
                    totalItems: TotalCount,
                    currentPage: CurrentPage,
                }">
                    <div class="col-12 col-md-6 mb-3">
                        <app-advertisement-card [info]="land" />
                    </div>
                </ng-container>
            </ng-container>
            <!-- end lands -->

            <ng-template #emptyLands>
                <ng-container *ngIf="ActiveZone != null && !(IsLoading | async)">
                    <div class="col-12">
                        <h3 class="font_20 font_600 text-center text-danger my-4">لا يوجد مناطق داخل المشروع</h3>
                    </div>
                </ng-container>
            </ng-template>

            <ng-container *ngIf="Lands.length > 0">
                <div class="col-12 mt-3">
                    <div class="wrap_pagination text-center">
                        <pagination-controls 
                            [maxSize]="5"
                            nextLabel="التالي"
                            [responsive]="true"
                            class="label_lg_bold"
                            previousLabel="السابق"
                            screenReaderPageLabel="page"
                            (pageChange)="PageChange($event)"
                            screenReaderPaginationLabel="Pagination"
                            screenReaderCurrentLabel="You're on page"
                        />
                    </div>
                </div>
            </ng-container>

        </div>
        <!-- end zone details -->

    </div>
</div>